import React, { useState, useEffect } from 'react';
import { collection, addDoc, onSnapshot, serverTimestamp } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import './AddProduct.css';
import { db, storage } from '../firebase/firebase-config';

const AddProduct = () => {
  const [formData, setFormData] = useState({ 
    name: '', 
    id: '', 
    price: '', 
    cat: '', 
    size: 'small', 
    material: '', 
    cut: '',
    measure: '', // Kanka kondisyon gitti, yerine 'Ölçü' geldi
    description: '' 
  });
  
  const [dbCats, setDbCats] = useState([]);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const unsub = onSnapshot(collection(db, "categories"), (snap) => {
      setDbCats(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });
    return () => unsub();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (images.length === 0) return alert("Kanka en az bir görsel yüklemelisin!");
    if (!formData.cat) return alert("Lütfen bir kategori seç kanka!");

    setLoading(true);
    try {
      const urls = await Promise.all(images.map(async (img) => {
        const r = ref(storage, `products/${Date.now()}_${img.name}`);
        await uploadBytes(r, img);
        return getDownloadURL(r);
      }));

      await addDoc(collection(db, "products"), {
        ...formData,
        img: urls[0],
        allImages: urls,
        createdAt: serverTimestamp()
      });

      alert("Eser başarıyla koleksiyona eklendi kanka!");
      // Formu temizlerken ölçü alanını da temizle
      setFormData({ name: '', id: '', price: '', cat: '', size: 'small', material: '', cut: '', measure: '', description: '' });
      setImages([]);
    } catch (err) { 
      console.error(err);
      alert("Hata çıktı kral.");
    }
    setLoading(false);
  };

  return (
    <div className="premium-add-wrapper">
      <form onSubmit={handleSubmit} className="premium-admin-form">
        <div className="form-main-grid">
          
          <div className="p-input-group">
            <label>Ürün Adı</label>
            <input type="text" value={formData.name} placeholder="Osmanlı Sıkma" onChange={e => setFormData({...formData, name: e.target.value})} required />
          </div>

          <div className="p-input-group">
            <label>Kategori</label>
            <select value={formData.cat} onChange={e => setFormData({...formData, cat: e.target.value})} required>
              <option value="">Seçiniz...</option>
              {dbCats.map((c, i) => (
                <option key={i} value={c.slug}>{c.title}</option>
              ))}
            </select>
          </div>

          <div className="p-input-group">
            <label>Lot No</label>
            <input type="text" value={formData.id} placeholder="Örn: T777" onChange={e => setFormData({...formData, id: e.target.value})} required />
          </div>

          <div className="p-input-group">
            <label>Habbe Ölçüsü</label>
            <input type="text" value={formData.measure} placeholder="Örn: 8x12 mm" onChange={e => setFormData({...formData, measure: e.target.value})} />
          </div>

          <div className="p-input-group">
            <label>Fiyat / Durum Notu</label>
            <input type="text" value={formData.price} placeholder="2.200 ₺ veya Özel Seri" onChange={e => setFormData({...formData, price: e.target.value})} required />
          </div>

          <div className="p-input-group">
            <label>Malzeme</label>
            <input type="text" value={formData.material} placeholder="Ateş Kehribar" onChange={e => setFormData({...formData, material: e.target.value})} />
          </div>

          <div className="p-input-group">
            <label>Kesim</label>
            <input type="text" value={formData.cut} placeholder="Sistemli / Beyzi / Kapsül" onChange={e => setFormData({...formData, cut: e.target.value})} />
          </div>

          <div className="p-input-group">
            <label>Kart Boyutu (Ana Sayfa)</label>
            <select value={formData.size} onChange={e => setFormData({...formData, size: e.target.value})}>
              <option value="small">Standart (Kare)</option>
              <option value="tall">Uzun (Dikey)</option>
              <option value="wide">Geniş (Yatay)</option>
            </select>
          </div>

        </div>

        <div className="p-input-group full-width" style={{marginTop: '20px'}}>
            <label>Eser Hikayesi & Açıklama</label>
            <textarea rows="3" value={formData.description} placeholder="Usta ismi veya ürünün özel hikayesi..." onChange={e => setFormData({...formData, description: e.target.value})} />
        </div>

        {/* Görsel Yükleme Alanı Aynı Kalsın kanka... */}
        <div className="upload-section">
          <label className="upload-box-label">
            <span>Görselleri Seç (Çoklu Seçim)</span>
            <input type="file" multiple onChange={e => setImages([...images, ...Array.from(e.target.files)])} hidden />
          </label>
          <div className="preview-row">
            {images.map((img, i) => (
              <div key={i} className="preview-item">
                <img src={URL.createObjectURL(img)} alt="önizleme" />
                <button type="button" onClick={() => setImages(images.filter((_, index) => index !== i))}>x</button>
              </div>
            ))}
          </div>
        </div>

        <button type="submit" className="final-submit-btn" disabled={loading}>
          {loading ? "KOLEKSİYONA İŞLENİYOR..." : "ESERİ SİSTEME KAYDET"}
        </button>
      </form>
    </div>
  );
};

export default AddProduct;